import { DOWNLOAD_ANCHOR, LOGIN_URL } from '@/lib/landing'
import { ButtonLink, GenieMark } from './primitives'

const LINKS = [
  { label: 'Session', href: '#how' },
  { label: 'Features', href: '#features' },
  { label: 'Models', href: '#models' },
  { label: 'Magic Lamp', href: '#magic-lamp' },
] as const

export function Nav() {
  return (
    <header className="sticky top-0 z-40 bg-canvas/90 backdrop-blur-md">
      <div className="landing-shell flex h-[60px] items-center gap-8">
        <a href="/" className="flex items-center gap-2 text-ink no-underline" aria-label="Genie, home">
          <GenieMark className="size-[20px]" />
          <span className="display text-[17px] leading-none">Genie</span>
        </a>

        <nav className="ml-auto hidden items-center gap-7 md:flex" aria-label="Primary">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} className="text-[14px] text-ink-2 no-underline transition-colors hover:text-ink">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 md:ml-0">
          <ButtonLink href={LOGIN_URL} variant="outline" size="sm">
            Sign in
          </ButtonLink>
          <ButtonLink href={DOWNLOAD_ANCHOR} size="sm">
            Download <span aria-hidden>↓</span>
          </ButtonLink>
        </div>
      </div>
    </header>
  )
}
